const JIVO_SCRIPT_ID = 'jivo-widget-script';

function ensureScriptLoaded() {
	if (!App?.jivo?.id) return;

	const existing = document.getElementById(JIVO_SCRIPT_ID);
	if (existing) return;

	const script = document.createElement('script');
	script.id = JIVO_SCRIPT_ID;
	script.async = true;
	script.src = `https://code-eu1.jivosite.com/widget/${App.jivo.id}`;
	document.head.appendChild(script);
}

function bootJivo() {
	if (!App?.jivo?.id) return;

	// Turbo can replace body and remove widget DOM,
	// so we re-run jivo_init when script is already present.
	if (typeof window.jivo_init === 'function') {
		window.jivo_init();
		return;
	}

	ensureScriptLoaded();
}

document.addEventListener('DOMContentLoaded', bootJivo);
typeof onTurboRender !== 'undefined' && onTurboRender(bootJivo);
